import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faListUl,
  faPenToSquare,
  faEye,
  faDownload,
  faBomb,
} from "@fortawesome/sharp-light-svg-icons";
import { Box, Grid, IconButton, Tooltip } from "@mui/material";
import { IconDefinition } from "@fortawesome/sharp-solid-svg-icons";

interface CustomIconsForBubbleProps {
  title?: string;
  tag: string;
  buttons: {
    icon: "faListUI" | "faPenToSquare" | "faEye" | "faDownload";
    type: "view" | "edit" | "download";
    tooltip: string;
    action?: () => void;
  }[];
  children?: React.JSX.Element;
}

/**
 * @deprecated Use ActionBubble instead.
 */
export const CustomIconsForBubble = ({
  title,
  tag,
  buttons,
  children,
}: CustomIconsForBubbleProps) => {
  function selectIcon(iconString: string): IconDefinition {
    switch (iconString) {
      case "faListUI":
        return faListUl;
      case "faPenToSquare":
        return faPenToSquare;
      case "faEye":
        return faEye;
      case "faDownload":
        return faDownload;
      default:
        return faBomb;
    }
  }

  return (
    <Grid container>
      <Grid item xs={"auto"}>
        {title && (
          <Box component={"span"} sx={{ fontWeight: 700, lineHeight: "32px" }}>
            {title}
          </Box>
        )}
        {children}
      </Grid>
      <Grid item xs={"auto"}>
        <div data-testid={`${tag}-details`} style={{ paddingLeft: "30px" }}>
          {buttons.map((button, index) => {
            const margin: string = index > 0 ? "3px" : "0px";
            const random: number = Math.random();

            return (
              <Tooltip
                title={button.tooltip}
                placement="top"
                key={`${button.type}-custom-button-${random}`}
                arrow
              >
                <IconButton
                  onClick={button.action}
                  size="small"
                  sx={{
                    width: "40px",
                    height: "36px",
                    borderRadius: 1,
                    border: "2px solid",
                    borderColor: "primary",
                    marginLeft: margin,
                  }}
                  aria-label={`${button.tooltip.toLowerCase()} button`}
                >
                  <FontAwesomeIcon
                    icon={selectIcon(button.icon)}
                    data-testid={`${tag}-${button.type}-icon`}
                  />
                </IconButton>
              </Tooltip>
            );
          })}
        </div>
      </Grid>
    </Grid>
  );
};
